import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "project" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "",
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bx bxl-github" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-link" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "body")
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.linkGit)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            target: "_blank",
            href: _ctx.linkGit
          }, _hoisted_8, 8, _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.link)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            target: "_blank",
            href: _ctx.link
          }, _hoisted_11, 8, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ]))
}